import { useCallback, useEffect, useMemo } from 'react';
import fetchTimezone from './fetchTimezone';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@app/appReducer';
import { TimezoneListI } from './types';

export const defaultCountryCode = 'GB';
const getTimezoneOptions = (
  list: TimezoneListI[]
): { value: string; label: string }[] =>
  list.map((item) => ({
    value: item.zone_name,
    label: item.zone_label,
  }));

export const getTimeZoneOption = (
  list: { value: string; label: string }[],
  selectedTimeZone: string
): { value: string; label: string } | null => {
  const option = list.find((item) => selectedTimeZone === item.value);
  return option
    ? { value: option.value || '', label: option.label || '' }
    : null;
};

const useGetTimezones = (): {
  timezoneList: { value: string; label: string }[];
  fetchCountryTimezone: (countryCode: string) => void;
} => {
  const dispatch = useDispatch();
  const list = useSelector((state: RootState) => state.timezone.list);

  useEffect(() => {
    (async (): Promise<void> => {
      dispatch(fetchTimezone(defaultCountryCode));
    })();
  }, [dispatch]);

  const fetchCountryTimezone = useCallback(
    (countryCode: string): void => {
      dispatch(fetchTimezone(countryCode));
    },
    [dispatch]
  );

  const timezoneOptions = useMemo(() => getTimezoneOptions(list || []), [list]);

  return {
    timezoneList: timezoneOptions,
    fetchCountryTimezone,
  };
};

export default useGetTimezones;
